import { reactive, toRefs } from '@vue/composition-api'


const TOKEN_KEY = 'accessToken'



export function createAuth(client) {

  const state = reactive({
    isReady: true, // original true
    isLoggedIn: false,
    accessToken: sessionStorage.getItem(TOKEN_KEY),
    user: {},

    isLoggingIn: false,
    hasErrors: false,
  })

  function authenticate() {

    if (!state.accessToken) {
      state.isReady = true
      return Promise.resolve()
    }
  
    return client.get('/users/me', { 
      headers: { Authorization: `Bearer ${state.accessToken}` },
      params: { expand: 'avatar' },
    })
      .then(response => {
        state.user = response.data
        state.isLoggedIn = true
        return Promise.resolve(true)
      })
      .catch(() => {
        state.isLoggedIn = false
        return Promise.resolve(false)
      })
      .finally(() => {
        state.isReady = true
      })
   
  }

  function ping(timeout = 60) {

    setInterval(() => {
      if (state.isLoggedIn) {
        client.get('/users/ping', { 
          headers: { Authorization: `Bearer ${state.accessToken}` },
          params: { ping: 1 },
        }).catch(error => {
          if (error && error.response && error.response.status === 401) {
            logout()
          }
        })
      }
    }, 1000 * timeout)

  }

  function setAccessToken(token) { 
    state.isLoggingIn = true
    state.hasErrors = false
    sessionStorage.setItem(TOKEN_KEY, token)
    // console.log("get token from session" + sessionStorage.getItem(TOKEN_KEY))
    state.accessToken = token
    state.user = {}
    state.isLoggedIn = true
    //return Promise.resolve()
  }

  function login(username, password) {
  
    state.isLoggingIn = true
    state.hasErrors = false
  
    return client.post('/users/login', { username, password })
      .then(response => {
        sessionStorage.setItem(TOKEN_KEY, response.data.accessToken)
        state.accessToken = response.data.accessToken
        state.user = response.data.user
        state.isLoggedIn = true
      })
      .catch(() => {
        sessionStorage.removeItem(TOKEN_KEY)
        state.accessToken = null
        state.user = {}
        state.isLoggedIn = false
        state.hasErrors = true
      })
      .finally(() => {
        state.isLoggingIn = false
      })
  
  }
  
  function logout() {
  
    sessionStorage.removeItem(TOKEN_KEY)
    state.accessToken = null
    state.user = {}
    state.isLoggedIn = false
  
    return Promise.resolve()
  
  }
  

  return {
    client,
    ...toRefs(state),
    authenticate,
    ping,
    login,
    logout,
    setAccessToken
  }
}

